export default function GlossaryResearchVoid() {
    // Used in GlossaryContent to display message
    // for empty result research

    // BUILD
    return (
        <div className="text-greyLight7">
            {"Aucun mot trouvé pour cette recherche"}
        </div>
    );
}